import React from "react";

export default function DocumentSubmissionType({
  name,
  handleChange,
  handleReset,
}) {
  return (
    <div className="">
      <div className="flex items-center">
        <div className="flex items-center pl-0">
          <input
            defaultChecked
            id="list-radio-license"
            type="radio"
            value="PICK_UP"
            onChange={handleChange}
            name={name}
            className="checkbox-round mr-2 leading-tight focus:ring-green-500"
          />
          <label
            htmlFor="list-radio-license"
            className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Pickup?
          </label>
        </div>
        <div className="flex items-center pl-3">
          <input
            id="list-radio-id"
            type="radio"
            value="PUBLIC_TRANSPORT"
            onChange={handleChange}
            name={name}
            className="checkbox-round mr-2 leading-tight focus:ring-green-500"
          />
          <label
            htmlFor="list-radio-id"
            className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Public Transport
          </label>
        </div>
        <div className="flex items-center pl-3">
          <input
            id="list-radio-millitary"
            type="radio"
            value="SELF_DELIVERY"
            name={name}
            onChange={handleChange}
            className="checkbox-round mr-2 leading-tight focus:ring-green-500"
          />
          <label
            htmlFor="list-radio-millitary"
            className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            I will deliver it myself
          </label>
        </div>
      </div>
    </div>
  );
}
